







import { defineComponent, onMounted } from '@vue/composition-api';
import router from '@/router';
import { RouterV2Enum } from '@/router/router-names';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';

export default defineComponent({
  name: 'BrandBar',
  setup() {
    const onBrandBarClick = () => {
      // 点击埋点
      ubtSetupPageButton('finance_loan_home_BrandShow', {});

      router.push({
        path: RouterV2Enum.aboutUs,
      });
    };

    // 曝光埋点
    onMounted(() => {
      ubtSetupModuleExpose('finance_loan_home_BrandShow', {});
    });

    return {
      onBrandBarClick,
    };
  },
});
